import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { ExcelService } from '../../excel.service';
// import { ViewTransactionLogComponent } from '../../transaction-log/view-transaction-log/view-transaction-log.component';

@Component({
  selector: 'app-list-leads',
  templateUrl: './list-leads.component.html',
  styleUrls: ['./list-leads.component.scss']
})
export class ListLeadsComponent implements OnInit {

  isLoading: boolean = true;
  downloadReport: boolean = false;
  isLoadingExtraData: boolean = false;

  dataToEdit: any;

  searchString: any = '';

  p: any = 1;
  count: any = 50;
  limit: any = 500;
  skip: any = 0;

  startDate: any;
  endDate: any;

  listOfLeads: any = [];
  listOfLeadsToDisplay: any = [];
  userDetails: any;

  status: string = 'SUCCESS';

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.fetchAllLead();
  }

  constructor(
    private matDialog: MatDialog,
    public as: AppService,
    public routes: ActivatedRoute,
    private router: Router, public excelExport: ExcelService,
    private toastr: ToastrService
  ) { }
  searchTransLog(event: any) {
    // console.log(event.target.value);
    this.searchString = event.target.value;
    let tempList: any = [];
    this.listOfLeadsToDisplay = [...this.listOfLeads];
    if (this.searchString != '') {
      this.listOfLeadsToDisplay.forEach((lead: any) => {
        if (

          String(lead['name'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(lead['phone'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(lead['source'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(lead['email'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase())
        ) {
          tempList.push(lead);
        }
      });
      this.listOfLeadsToDisplay = [...tempList];
    } else {
      this.listOfLeadsToDisplay = [...this.listOfLeads];
    }
  }
  async fetchAllLead() {
    this.isLoading = true;
    this.listOfLeads = [];
    this.listOfLeadsToDisplay = [];
    try {
      let URL = '';
      const param = {
        skip: this.skip,
        limit: this.limit,
        status: this.status,
        startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
        endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
      };
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetails['accessToken']}`,
      });
      URL = `${webApi.domain + webApi.endPoint.fetchAllLead}`;

      await this.as.fetchDetail(param, URL, httpHeaders).then((data: any) => {
        if (data['type']) {
          this.listOfLeads = data['result'];
          this.listOfLeadsToDisplay = this.listOfLeads;
          this.isLoading = false;
        } else {
          this.listOfLeads = [];
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.listOfLeads = [];
      this.isLoading = false;
    }
  }
  async fetchExtraTransactionLog(load: boolean,) {
    this.isLoadingExtraData = load;
    const param = {
      skip: this.skip,
      limit: this.limit,
      status: this.status,
      startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
      endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
    };
    const URL = `${webApi.domain + webApi.endPoint.fetchAllLead}`;
    await this.as
      .postMethod(param, URL,)
      .then((data: any) => {
        if (data['type']) {
          data['result'].forEach((user: any) => {
            this.listOfLeads.push(user);
          });
          this.isLoadingExtraData = false;
        } else {
          this.isLoadingExtraData = false;
        }
      });
  }

  clearDateRange() {
    if (this.endDate != null && this.startDate != null) {
      this.endDate = null;
      this.startDate = null;
      this.fetchAllLead();
      this.p = 1;
    }
  }

  setDateNull() {
    this.startDate = null;
    this.endDate = null;
    this.fetchAllLead();
  }

  async dateChanged(type: string, event: any) {
    if (type == 'start' && event.value != null) {
      this.startDate = new Date(event.value);
    } else if (type == 'end' && event.value != null) {
      this.endDate = new Date(event.value);
    }
    if (this.startDate != null && this.endDate != null) {
      this.fetchAllLead();
    }
  }
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // console.log('index => ', tabChangeEvent.index);
    this.searchString = '';
    if (tabChangeEvent.index == 0) {
      this.status = 'SUCCESS';
    } else {
      this.status = 'FAILED';
    }
    this.fetchAllLead();
  }
  pageChanged(event: any) {
    this.p = event;
    console.log(event);

    if (this.p * this.count >= this.listOfLeads.length - this.count * 3) {
      this.skip = this.skip + this.limit;
      if (!this.isLoadingExtraData) this.fetchExtraTransactionLog(false);
    } else if (this.p * this.count >= this.listOfLeads.length) {
      this.skip = this.skip + this.limit;
      this.fetchExtraTransactionLog(true);
    }


  }
  viewEditLog(transaction: any) {
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.data = { transaction: transaction };
    // dialogConfig.width = '45vw';
    // dialogConfig.maxWidth = '60vw';
    // dialogConfig.maxHeight = '85vh';
    // let dialogRef = this.matDialog.open(ViewTransactionLogComponent, dialogConfig);
    // dialogRef.updatePosition(dialogConfig.position);
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result != undefined) {
    //   }
    // });
    // dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
    //   // console.log(res);
    //   if (res == null) {
    //     return;
    //   } else { }
    // });
  }
  async generateLeadReport() {

    this.downloadReport = true;
    try {
      let URL = '';
      const param = {
        skip: this.skip,
        limit: this.limit,
        status: this.status,
        startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
        endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
      };
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetails['accessToken']}`,
      });
      URL = `${webApi.domain + webApi.endPoint.generateLeadReport}`;

      await this.as.fetchDetail(param, URL, httpHeaders).then((data: any) => {
        if (data['type']) {
          window.open(data['result']);
          this.downloadReport = false;
        } else {
          this.downloadReport = false;
        }
      });
    } catch (error) {
      this.downloadReport = false;
    }


  }


  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }


}
